import { useEffect } from "react";
import Nav from "@/components/wynn/Nav";
import Hero from "@/components/wynn/Hero";
import Studio from "@/components/wynn/Studio";
import Waitlist from "@/components/wynn/Waitlist";
import PhoneGallery from "@/components/wynn/PhoneGallery";
import ReliefSpotlight from "@/components/wynn/ReliefSpotlight";
import MeditationsSpotlight from "@/components/wynn/MeditationsSpotlight";
import CoachingSpotlight from "@/components/wynn/CoachingSpotlight";
import CoursesSpotlight from "@/components/wynn/CoursesSpotlight";
import CommunitySpotlight from "@/components/wynn/CommunitySpotlight";
import Features from "@/components/wynn/Features";
import FounderStory from "@/components/wynn/FounderStory";
import Philosophy from "@/components/wynn/Philosophy";
import Testimonials from "@/components/wynn/Testimonials";
import FAQ from "@/components/wynn/FAQ";
import BetaCTA from "@/components/wynn/BetaCTA";
import Footer from "@/components/wynn/Footer";

export default function Wynn() {
  useEffect(() => {
    document.title = "WYNN · Creative transformation in your pocket";
    const desc =
      "WYNN. A pocket companion for the inner artist. AI self-coaching, daily affirmations, meditations, journaling, and sound healing. Join the closed beta.";
    const setMeta = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement("meta");
        const m = sel.match(/\[(.*?)=["'](.*?)["']\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", "WYNN · Creative transformation in your pocket");
    setMeta('meta[property="og:description"]', "content", desc);
  }, []);

  return (
    <div data-testid="wynn-page" className="min-h-screen bg-[#070608] text-[#F4F1EC] flex flex-col">
      <Nav />
      <main className="flex-1">
        <Hero />
        <Studio />
        <Waitlist />
        <PhoneGallery />
        <ReliefSpotlight />
        <MeditationsSpotlight />
        <CoachingSpotlight />
        <CoursesSpotlight />
        <CommunitySpotlight />
        <Features />
        <FounderStory />
        <Philosophy />
        <Testimonials />
        <FAQ />
        <BetaCTA />
      </main>
      <Footer />
    </div>
  );
}
